import { render, staticRenderFns } from "./AddEditGroup.vue?vue&type=template&id=6068510a&scoped=true"
import script from "./AddEditGroup.vue?vue&type=script&lang=js"
export * from "./AddEditGroup.vue?vue&type=script&lang=js"
import style0 from "./AddEditGroup.vue?vue&type=style&index=0&id=6068510a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068510a",
  null
  
)

export default component.exports